import { DocumentData } from "@angular/fire/firestore";
import { MenuTipPercentageSettings } from "./menu.percentage.model";

export class MenuTipPercentageSettingsBuilder {
  private _minimum: number;
  private _one: number;
  private _two: number;
  private _three: number;
  constructor() {
    this.default();
  }

  public get minimum(): number {
    return this._minimum;
  }

  public set minimum(percent: number) {
    this._minimum = percent;
  }

  public get one(): number {
    return this._one;
  }

  public set one(percent: number) {
    this._one = percent;
  }

  public get two(): number {
    return this._two;
  }

  public set two(percent: number) {
    this._two = percent;
  }

  public get three(): number {
    return this._three;
  }

  public set three(percent: number) {
    this._three = percent;
  }

  private default(): void {
    this._minimum = 10;
    this._one = 15;
    this._two = 18;
    this._three = 20;
  }

  public load(data: DocumentData): MenuTipPercentageSettingsBuilder {
    this._minimum = data.minimum;
    this._one = data.one;
    this._two = data.two;
    this._three = data.three;
    return this;
  }

  public edit(
    settings: MenuTipPercentageSettings
  ): MenuTipPercentageSettingsBuilder {
    this._minimum = settings.minimum;
    this._one = settings.one;
    this._two = settings.two;
    this._three = settings.three;
    return this;
  }
  public build(): MenuTipPercentageSettings {
    return new MenuTipPercentageSettings(this);
  }

  public toJSON = () => ({
    minimum: this._minimum,
    one: this._one,
    two: this._two,
    three: this._three
  });
}
